// api/itrAPI.js
import axiosInstance from './axiosConfig';

const itrAPI = {
  // ── Income ────────────────────────────────────────────────────────
  getIncome: (clientId, params = {}) =>
    axiosInstance.get(`/itr/clients/${clientId}/income`, { params }),

  createIncome: (clientId, data) =>
    axiosInstance.post(`/itr/clients/${clientId}/income`, data),

  updateIncome: (recordId, data) =>
    axiosInstance.put(`/itr/income/${recordId}`, data),

  deleteIncome: (recordId) =>
    axiosInstance.delete(`/itr/income/${recordId}`),

  // ── Deductions ────────────────────────────────────────────────────
  getDeductions: (clientId, params = {}) =>
    axiosInstance.get(`/itr/clients/${clientId}/deductions`, { params }),

  createDeduction: (clientId, data) =>
    axiosInstance.post(`/itr/clients/${clientId}/deductions`, data),

  updateDeduction: (recordId, data) =>
    axiosInstance.put(`/itr/deductions/${recordId}`, data),

  deleteDeduction: (recordId) =>
    axiosInstance.delete(`/itr/deductions/${recordId}`),

  // ── ITR Tax Due Adjustment ────────────────────────────────────────
  getAdjustment: (clientId, params = {}) =>
    axiosInstance.get(`/itr/clients/${clientId}/adjustment`, { params }),

  saveAdjustment: (clientId, data) =>
    axiosInstance.post(`/itr/clients/${clientId}/adjustment`, data),

  // ── Summary ───────────────────────────────────────────────────────
  getSummary: (clientId, params = {}) =>
    axiosInstance.get(`/itr/clients/${clientId}/summary`, { params }),

  // ── GL Posting ────────────────────────────────────────────────────
  postRecordToGL: (clientId, data) =>
    axiosInstance.post(`/itr/clients/${clientId}/post-record-to-gl`, data),

  // ── Payments ───────────────────────────────────────────────────────
  getPayments: (clientId, params = {}) =>
    axiosInstance.get(`/itr/clients/${clientId}/payments`, { params }),

  recordPayment: (clientId, data) =>
    axiosInstance.post(`/itr/clients/${clientId}/record-payment`, data),

  // ── Helpers ───────────────────────────────────────────────────────
  getFiscalYearOptions: (count = 6) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: count }, (_, i) => ({
      value: currentYear - i,
      label: String(currentYear - i),
    }));
  },
};

export default itrAPI;
